import { useEffect, useState } from 'react';

interface LoadingMessage {
  message: string;
  duration: number;
}

export function useLoadingMessages(messages: LoadingMessage[]) {
  const [loadingMessage, setLoadingMessage] = useState<LoadingMessage>(messages[0]);
  if (!messages.length) {
    return undefined;
  }
  useEffect(() => {
    let messageIndex = 0;
    const interval = setInterval(() => {
      messageIndex = (messageIndex + 1) % messages.length;
      setLoadingMessage(messages[messageIndex]);
    }, loadingMessage.duration);

    return () => {
      clearInterval(interval);
    };
  }, [messages]);

  return loadingMessage.message;
}
